import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    statusButton: {
        borderRadius: "16px",
        padding: "10px",
        background: "rgba(0, 0, 0, 0.08)",
    },
    userImageWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 50,
        height: 50,
        borderRadius: "100%",
        backgroundColor: theme.palette.graphs.main,
    },
    userImage: {
        width: 50,
        height: 50,
        borderRadius: "100%",
        objectFit: "cover" as "cover",
    },
}));
